<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>热心公益献爱心，关怀长者传美德!</h2>
        <img width="100%" :src="img[0]" alt="">
        <p>
          9月11日上午9:30，厚街镇敬老院许仰信院长、卢培兴副院长驱车从厚街赶到广东东进有害生物防控技术有限公司，亲手给东进公司赠送“热公益献爱心，关怀长者传美德”锦旗，以此感谢东进公司为敬老院提供公益除四害消杀服务，为敬老院老人创造一个安全健康的居住环境。
        </p>
        <p>
          许仰信院长对爱卫之家公益服务单位--东进公司给与了较高的评价，东进公司王伟总经理重视爱卫之家公益服务，亲自安排布置消杀任务，多次督察消杀效果，并给敬老院老人带来慰问，是一位有公益心和责任心的企业家。东进公司每月定时安排消杀工作，带队人员与我院人员主动沟通，仔细勘察现场，认真安排工作，对我院进行全面杀虫灭鼠。还对我院发现的白蚁危害进行了有效的防治。使我院的鼠害和蚊虫密度得到了有效控制，保障了老人们的健康。
        </p>
        <p>
          东莞市有害生物防制协会徐兵兵执行秘书长、宋明亮理事与许仰信院长、卢培兴副院长:东进公司王伟总经理进行了亲切友好的交流。徐兵兵秘书长给大家介绍了协会爱卫之家公益活动的推进情况与取得的效果，其中东进公司是今年5月16日与厚街敬老院签署“爱卫之家公益服务协议书”，正式为厚街敬老院提供公益消杀服务，所提供的服务得到敬老院的认可，让我们看到越来越多的像王总一样的企业家积极投身到社会公益事业，传播正能量，协会有信心把公益服务做得更好，做出“爱卫之家”服务品牌。
        </p>
        <p>
          许仰信院长感谢东莞协会的正能量，带动广大会员践行公益，是一个有担当，做实事，充满正能量的社会团体。东进公司王总表示今后会不负符老院许院长期望，力争把爱卫之家公益活动开展得更加完美，为老人们安全健康的居住环境尽一份绵薄之力。参会的宋明亮理事深受感染，表示业行受益匪浅，不虚此行，以后身体力行，积极参加公益活动，向正能量的企业和个人学习。
        </p>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[0]" alt="">
          </el-col>
          <el-col :span="12" :xs="24" :offset="0">
            <img width="100%" :src="img[1]" alt="">
          </el-col>
        </el-row>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News2'})">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;广东东进在行动</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News0'})">热烈庆祝广东东进...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News0'})">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;热烈庆祝广东东进...</span>
        </el-col>
      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news4.png'), require('@/assets/news4-1.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>